import React, { Component } from "react";
import { Button, Col, DatePicker, Form, Input, Row, Select, Spin, message } from "antd";
import { StoreContext } from "../store/RootStore";
import { observer } from "mobx-react";
import withRouter from "../withRouter";

import CompanyAutocomplete from "./CompanyAutocomplete";
import config from "../config";

import CompanyStore from "../store/CompanyStore";


import Cookies from "universal-cookie";
import ProjectStore from "../store/ProjectStore";
class ProjectAdd extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      loadingSpin: false,
      companyId: "",
      id: -1,
      photo: "",
      showType: "",
      folderName: "",
      token: "",
    };

    this.projectStore = new ProjectStore(this);
    this.companyStore = new CompanyStore(this);
    this.cookies = new Cookies();
  }
  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
    }
    const projectId = this.props.projectId;
    const companyId = this.props.companyId;
    console.log("project Id", projectId)
    if (projectId) {
      await this.filldata(projectId, companyId);
    }

    this.setState({ update: 1 });
  }
  async handleChange(comp) {
    await this.setState({ companyId: comp.value });

  }
  async filldata(projectId, companyId) {
    const getProjectData = await this.projectStore.getProjectDetails(companyId, projectId);

    await this.setState({ Id: getProjectData.projectId, companyId: companyId, projectId: projectId });
    const singleData = await this.companyStore.getCompanyDataById(
      getProjectData[0].companyId
    );
    await this.formRef.current.setFieldsValue({
      Id: getProjectData[0].projectId,
      projectName: getProjectData[0].projectName,
      companyId: singleData
    });
  }
  handleFormSubmit = async (values) => {
    const data = { project: { proname: values.projectName, companyId: this.state.companyId, projectId: this.state.projectId } };
    console.log(data)
    const response = await this.projectStore.addProjectData(data);
    await this.projectStore.getProjectDetails(this.state.companyId);
    console.log(response);

    await this.props.response(response);
    this.setState({ loading: false });
    this.formRef.current?.resetFields();
    this.props.closeModal();
  };

  closeModal = () => {
    this.props.closeModal();
    this.setState({ openProjectForm: false, projectId: "" });
    this.formRef.current?.resetFields();
  };

  responseMsg = async (resp) => {
    console.log(resp)
    if (resp.success === "S") {
      message.success(resp.message);
      await this.setState({ listDataUpdate: true });
      await this.setState({ openProjectForm: false });
      await this.handleSearch();
    } else {
      message.error(resp.message);
    }
  };


  render() {
    return (
      <div style={{ padding: 0, height: "100%" }}>
        <div style={{ paddingBottom: "10px", height: "100%" }}>
          <Spin spinning={this.state.loadingSpin} fullscreen>
            <Form
              name="fileimport"
              layout="vertical"
              onFinish={this.handleFormSubmit}
              style={{ padding: "0px 10px" }}
              ref={this.formRef}
              className="formClass"
            >
              <Row className="overflowFormInputs">
                <Col span={12} className="formColumnClass">
                  {(this.props.getUserData().isadmin === -1 ||
                    this.props.getUserData().isadmin === 3) && (
                      <Form.Item
                        name="companyId"
                        label={
                          <span>
                            {this.context.translate("_ACCOUNT_")}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        rules={[
                          {
                            required: true,
                            message: `${this.context.translate(
                              "_FLEET_DRIVER_DRIVERDETAIL_COMPANY_"
                            )} ${this.context.translate("_IS_REQUIRED_")}`,
                          },
                        ]}
                        required={false}
                        className="uploadCompany"
                      >
                        <CompanyAutocomplete
                          onChange={(value) => this.handleChange(value)}
                          style={{ width: "100%" }}
                          value={this.state.companyId}
                        />
                      </Form.Item>
                    )}
                  <Form.Item
                    name="projectName"

                    label={
                      <span>
                        {this.context.translate("_PROJECT_NAME_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                      },
                    ]}


                  >
                    <Input />
                  </Form.Item>

                </Col>

              </Row>

              <div className="formFooter">
                <Button
                  className="formsCancelButton"
                  onClick={() => this.closeModal()}
                >
                  {this.context.translate(
                    "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                  )}
                </Button>
                <Button
                  htmlType="submit"
                  className="formsSaveButton"
                // onClick={() => this.onExcelSubmit()}
                >
                  {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}

                </Button>
              </div>
            </Form>
          </Spin>
        </div>
      </div>
    );
  }
}
ProjectAdd.contextType = StoreContext;
export default observer(withRouter(ProjectAdd));
